<template>
	<q-circular-progress
		show-value
		class="text-light-dark"
		:value="portal.currentNavIndex"
		:max="portal.getTotalPages()"
		track-color="grey-3"
		size="70px"
		color="primary"
		:thickness="0.1"
		id="circularProgress"
	>
		<span class="text-weight-bold" id="circularProgressCounter">
			{{ portal.currentNavIndex }}/{{ portal.getTotalPages() }}
		</span>
	</q-circular-progress>
</template>

<style lang="less" scoped src="./circular-progress.less"></style>
<script lang="ts" src="./circular-progress.ts"></script>
